import {
  DocumentOrganizationKeys,
  FilterDocument,
  ReorderSectionUpdate,
} from '@griply/types';
import { buildSmartListReorderUpdate } from '@griply/utils';
import { useUpdateSmartList } from 'features/smart-lists';
import { useUpdateTasks } from 'features/tasks';
import { useCallback } from 'react';
import { useUpdateRelationshipsReferences } from 'shared/hooks/use-update-relationships-references';
import { RelationshipUpdate } from 'shared/types/relationship';
import { SmartList } from 'shared/types/smart-list';
import { GroupByMode } from 'shared/types/sorting-mode';
import { UpdateTask } from 'shared/types/task';

export const useSmartListOnReorder = (
  filterDocument: FilterDocument,
  smartList?: SmartList,
) => {
  const { submit: updateSmartList } = useUpdateSmartList();
  const { submit: updateTasks } = useUpdateTasks();
  const updateRelationships = useUpdateRelationshipsReferences();

  return useCallback(
    (
      updatedSections: ReorderSectionUpdate[],
      updatedTasks: UpdateTask[],
      relationshipUpdates?: RelationshipUpdate[],
    ) => {
      if (!smartList) {
        return;
      }

      updateTasks(updatedTasks);

      const groupByMode =
        filterDocument[DocumentOrganizationKeys.GroupByMode] ??
        GroupByMode.Priority;

      const update = buildSmartListReorderUpdate({
        smartList,
        updatedSections,
        groupByMode,
      });

      if (update) {
        updateSmartList(update);
      }

      if (relationshipUpdates?.length) {
        updateRelationships(relationshipUpdates);
      }
    },
    [
      filterDocument,
      smartList,
      updateSmartList,
      updateRelationships,
      updateTasks,
    ],
  );
};
